import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";

const ImagePreviewer = ({
  medias,
  visible,
  setVisible,
  selectedPostIdx,
  setSelectedPostIdx,
}) => {
  return (
    <Lightbox
      open={visible}
      close={() => setVisible(false)}
      slides={medias}
      plugins={[Video]}
      index={selectedPostIdx}
      on={{
        view: ({ index }) => setSelectedPostIdx(index),
      }}
    />
  );
};

export default ImagePreviewer;
